import React from 'react'

type Props = {
    brandId?: any
}

const _color = {
    31:'#6778E3',
    32:'#6778E3',
    33:'#b21418',
    34:'#b21418',
    39:'#e67030',
    40:'#e67030',
    46:'#08a6ff',
    47:'#08a6ff'
   
}

function CryptoWithdrawalIcon({ brandId=31 }: Props) {
    const fillColor = _color[brandId] || '#6778E3';

    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="57" height="57" viewBox="0 0 57 57" fill="none">
            <path d="M13.5834 13.8615C13.5834 14.8445 13.5834 15.6903 13.5834 16.6162C13.9606 16.6162 14.2921 16.6162 14.6235 16.6162C24.0991 16.6162 33.5862 16.6162 43.0618 16.6162C46.0794 16.6162 47.7139 18.2392 47.7139 21.2454C47.7139 28.1949 47.7139 35.133 47.7139 42.0826C47.7139 45.043 46.0679 46.6775 43.1189 46.6775C32.5003 46.6775 21.8817 46.6775 11.2631 46.6775C8.37124 46.6775 6.71387 45.0201 6.71387 42.1169C6.71387 34.2072 6.71387 26.2861 6.71387 18.3764C6.71387 14.0444 9.6057 11.1411 13.9377 11.1411C21.9388 11.1411 29.94 11.1411 37.9296 11.1411C39.8728 11.1411 41.3816 12.1698 41.8731 13.8501C32.4546 13.8615 23.059 13.8615 13.5834 13.8615Z" fill="#fff" />
            <path fill-rule="evenodd" clip-rule="evenodd" d="M27.1971 23.4768C28.3368 23.9613 29.3676 24.6697 30.2282 25.5601C31.0889 26.4505 31.7619 27.5048 32.2073 28.6603L28.7949 28.7273C28.2229 27.8035 27.4194 27.0453 26.464 26.5278C25.5086 26.0104 24.4346 25.7517 23.3484 25.7774C19.9131 25.8446 17.1785 28.6352 17.2392 32.0107C17.2999 35.3863 20.1375 38.0673 23.5739 37.9998C24.6611 37.9823 25.7249 37.6815 26.6603 37.1271C27.5957 36.5727 28.3703 35.7838 28.9076 34.8385L32.3197 34.7703C31.9171 35.943 31.2835 37.023 30.4563 37.9466C29.6292 38.8702 28.6253 39.6186 27.504 40.1476L27.5758 44.0335L24.4644 44.0953L24.4079 41.0078C23.8909 41.0598 23.3706 41.07 22.852 41.0381L22.9097 44.1253L19.798 44.1859L19.7262 40.3001C16.4872 38.9142 14.1973 35.771 14.129 32.0722C14.0606 28.3734 16.2328 25.1416 19.4194 23.6293L19.3476 19.7434L22.459 19.6817L22.5155 22.7691C23.0324 22.7171 23.5528 22.707 24.0713 22.7388L24.0137 19.6516L27.1253 19.591L27.1971 23.4768Z" fill={fillColor} />
            <path d="M43.1532 31.8345C43.1878 34.0835 41.35 35.9865 39.1134 36.0384C36.8074 36.0903 34.8828 34.2046 34.8828 31.9037C34.8828 29.6547 36.738 27.7863 38.992 27.769C41.2286 27.7344 43.1185 29.5855 43.1532 31.8345Z" fill={fillColor} />
        </svg>
    )
}

export function CryptoWithdrawalIcon2({ brandId=31 }: Props) {
    return (
        <svg
        xmlns="http://www.w3.org/2000/svg"
        width={33}
        height={33}
        fill="none"
        className='CryptoWIcon2'
      >
        <path
          fill="#fff"
          fillRule="evenodd"
          d="M19.214 11.171a6.068 6.068 0 0 1 3.289 3.403l-2.24.044a4.091 4.091 0 0 0-3.576-1.936c-2.254.044-4.05 1.875-4.01 4.091.04 2.216 1.903 3.976 4.159 3.931a4.103 4.103 0 0 0 3.5-2.075l2.24-.044a6.088 6.088 0 0 1-3.16 3.53l.046 2.55-2.042.04-.037-2.026c-.34.034-.68.04-1.021.02l.038 2.026-2.043.04-.047-2.55c-2.126-.91-3.63-2.974-3.674-5.401-.045-2.428 1.38-4.55 3.473-5.542L14.06 8.72l2.043-.04.037 2.026c.34-.034.68-.04 1.021-.02l-.038-2.026 2.043-.04.047 2.55Z"
          clipRule="evenodd"
        />
        <circle
          cx={16.511}
          cy={16.55}
          r={11.476}
          stroke="#fff"
          strokeWidth={1.601}
          transform="rotate(24.183 16.511 16.55)"
        />
      </svg>
    )
}

export default CryptoWithdrawalIcon